import {
  Box,
  Button,
  Heading,
  Image,
  Link,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import Typical from "react-typical";
import styles from "./Css/Home.module.css";


export default function Home() {
  return (
    <Box
      className={styles.homeBody}
  
    // bg={useColorModeValue("white", "gray.800")}
    // color={useColorModeValue("gray.300", "gray.600")}
    // bgImage={useColorModeValue("radial-gradient(circle, #04151f, #133d4f, #196a83, #189bb8, #12d0eb)", "gray.800")}
    >
      <Heading
        id="home"
        fontSize={{ base: "100px", sm: "160px", md: "250px" }}
        color={useColorModeValue("gray.300", "gray.600")}
        className={styles.homeHeading}
        fontFamily="'Playfair Display', serif"
      >
        Home
      </Heading>

      <SimpleGrid
        columns={{ base: 1, sm: 1, md: 2 }}
        spacing="0px"
        id="home"
        className={styles.home}
      >
        <Box
          //  bg="tomato"
          className={styles.homeLeft}
          height="550px"
        >
          <Box display="flex" justifyContent="center" alignItems="center">
            <Heading
              color="blue.300"
              fontFamily="'Playfair Display', serif"
              as="h3"
              fontSize={{ base: "20px", sm: "30px", md: "40px" }}
            >
              Hello, I Am{" "}
            </Heading>
            <Image
              maxW="80px "
              src="https://raw.githubusercontent.com/MartinHeinz/MartinHeinz/master/wave.gif"
            />
          </Box>
          <Heading
            fontFamily="'Playfair Display', serif"
            as="h1"
            color="royalBlue"
            fontSize={{ base: "40px", sm: "40px", md: "95px" }}
          >
            Ashish Kohad
          </Heading>
          <Heading
            fontFamily="'Playfair Display', serif"
            as="p"
            bg=""
            color="blue.300"
            fontSize={{ base: "25px", sm: "25px", md: "40px" }}
          >
            <Typical
              steps={[
                "Full Stack Web Developer",
                5000,
                "Tech Enthusiast",
                3000,
              ]}
              loop={Infinity}
              wrapper="p"
            />
          </Heading>
          <Box className={styles.contactOnHome}>
            <Link href="Resume/Ashish_Kohad_Resume.pdf"
              download="Ashish_Kohad_Resume" >
              <Button fontWeight="bold" fontSize="22px">Resume</Button>
            </Link>

            <Link href="https://github.com/AshishKohad27" target="_blank">
              <Button fontWeight="bold" fontSize="22px">
                <BsGithub />
              </Button>
            </Link>

            <Link href="https://www.linkedin.com/in/ashish-kohad27/" target="_blank">
              <Button fontWeight="bold" fontSize="22px">
                <BsLinkedin />
              </Button>
            </Link>
          </Box>
        </Box>

        <Box
          // bg="green.300"
          height="550px"
          className={styles.homeRight}
        >
          <Image src={"image/ProfilePhoto.png"} maxW="300px" />
        </Box>
      </SimpleGrid>
    </Box >
  );
}
